import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { NoteAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-authorisation-slot',
    templateUrl: './authorisation-slot.component.html',
    styleUrl: './authorisation-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthorisationSlotComponent implements SheetSlotComponentBase {

	@Input() action!: NoteAction;
	value = null;

	constructor() {
	}
}